import React from 'react';

interface APIProviderPillProps {
  provider: 'groq' | 'openai';
  fallbackReason?: string | null;
  className?: string;
}

export const APIProviderPill: React.FC<APIProviderPillProps> = ({ 
  provider, 
  fallbackReason,
  className = '' 
}) => {
  // 🔍 DEBUG: Log APIProviderPill props
  console.log('🔍 [APIProviderPill] Rendering with props:');
  console.log('🔍 [APIProviderPill] provider:', provider === 'groq' ? 'G' : 'O');
  console.log('🔍 [APIProviderPill] fallbackReason:', fallbackReason);
  console.log('🔍 [APIProviderPill] className:', className);
  
  const isGroq = provider === 'groq';
  
  const baseClasses = "inline-flex items-center justify-center px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer";
  
  const providerClasses = isGroq
    ? "bg-green-100 text-green-800 border border-green-200 hover:bg-green-200"
    : "bg-blue-100 text-blue-800 border border-blue-200 hover:bg-blue-200";
  
  const tooltipContent = fallbackReason 
    ? `${isGroq ? 'Primary AI Service' : 'Backup AI Service'} - Service issue detected`
    : `${isGroq ? 'Primary AI Service' : 'Backup AI Service'} active`;
  
  // 🔍 DEBUG: Log render decision
  console.log('🔍 [APIProviderPill] Rendering with classes:', `${baseClasses} ${providerClasses} ${className}`);
  console.log('🔍 [APIProviderPill] Will show letter:', isGroq ? 'G' : 'O');
  console.log('🔍 [APIProviderPill] Will show fallback dot:', !!fallbackReason);

  return (
    <div 
      className={`${baseClasses} ${providerClasses} ${className}`}
      title={tooltipContent}
      role="status"
      aria-label={`AI Provider: ${provider}`}
    >
      <span className="font-bold text-sm mr-1">
        {isGroq ? 'G' : 'O'}
      </span>
      {/* Status dot - green for primary service, yellow for fallback */}
      <span 
        className={`ml-1 w-2 h-2 rounded-full ${
          isGroq && !fallbackReason 
            ? 'bg-green-500 animate-pulse' 
            : fallbackReason 
              ? 'bg-yellow-400 animate-pulse' 
              : 'bg-blue-500 animate-pulse'
        }`}
        title={
          isGroq && !fallbackReason 
            ? 'Primary service active' 
            : fallbackReason 
              ? 'Fallback active' 
              : 'Backup service active'
        }
        aria-label={
          isGroq && !fallbackReason 
            ? 'Primary service active' 
            : fallbackReason 
              ? 'Fallback active' 
              : 'Backup service active'
        }
      />
    </div>
  );
};

export default APIProviderPill;